import { type FC, forwardRef } from 'react';
import classNames from 'classnames/bind';
import { Theme } from '../types/enums';
import { FAIcon } from '../Icons/Icons';
import { TagStyle, TagWidth } from './types/enums';
import { type TagPropsTypes, type TagTheme } from './types/propsType';
import styles from './Tag.module.scss';

const cx = classNames.bind(styles);

/**
 * @description This component provides badge or tag wrapped with style;
 * Props -> text (Required), theme ,icon and others.
 * Prop -> target dafault value is _self.
 */
const Tag: FC<TagPropsTypes> = forwardRef<HTMLSpanElement, TagPropsTypes>(
  ({ text, theme = Theme.BLACK, className, icon, tagWidth = TagWidth.FIT_CONTENT, style = TagStyle.SOLID }, ref) => {
    const CClassname = cx('base', [style], [theme], className, [tagWidth]);
    return (
      <span className={CClassname} ref={ref} data-testid="tag-testid">
        {icon && <FAIcon {...icon} theme={theme} className={`${styles['icon']} ${styles['icon-left']}`} />}
        {text}
      </span>
    );
  },
);

Tag.displayName = 'Tag';
export default Tag;
export { TagStyle, TagWidth };
export type { TagPropsTypes, TagTheme };
